import React, { memo } from 'react'
import { number, oneOfType, string } from 'prop-types'

export const CheckMark = memo(({ alt = 'checkmark', fill = '#00788D', height = '20px', width = '20px' }) => {
	return (
		<svg
			alt={alt}
			height={height}
			width={width}
			viewBox="0 0 20 20"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
				<g
					id="1---MBP-Catagory-Page---Best-Picks---Desktop-No-b.-Sure-Branding-3-Cards"
					transform="translate(-361.000000, -4047.000000)"
					fill={fill}
				>
					<g id="Section-5---Our-Reviews-1---Vast" transform="translate(360.000000, 3758.000000)">
						<g id="Review-1---Vast" transform="translate(0.000000, 0.614793)">
							<g id="Check-List" transform="translate(1.000000, 288.385207)">
								<g id="Line1">
									<g id="ico_check_sm">
										<path
											d="M10,-5.32907052e-14 C4.4800002,-5.32907052e-14 2.13162821e-14,4.48 2.13162821e-14,10 C2.13162821e-14,15.519997 4.4800002,20 10,20 C15.5200012,20 20,15.519997 20,10 C20,4.48 15.5200012,-5.32907052e-14 10,-5.32907052e-14 Z M8.0000002,14.999997 L3.0000002,10 L4.4100002,8.59 L8.0000002,12.169997 L15.5900012,4.58 L17.0000002,6 L8.0000002,14.999997 Z"
											id="Fill-1"
										></path>
									</g>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
})

CheckMark.propTypes = {
	alt: string,
	fill: string,
	height: oneOfType([string, number]),
}
